import React, { useState } from 'react';
import {
  AlertModal,
  modalPresets,
} from '../../Components/CustomComponents/Modals';

const ReturnedErrorMessages = ({
  existingCaseId,
  returnedErrorMsg,
  setErrorId,
  replyMsg,
  setReplyMsg,
}) => {
  const [alertModal, setAlertModal] = useState(modalPresets().default);

  return (
    <>
      {returnedErrorMsg && returnedErrorMsg.length > 0 && existingCaseId && (
        <section className="error-messages">
        <h2 className="ut-color-red">Error Messages</h2>
        <ul className="error-messsages__list">
          {returnedErrorMsg.map((error) => (
            <div key={error.id}>
              {!error.reply && (
                <div>
                  <label className="label">Reply to Error Messages:</label>
                  <p className="text-helper">Reply limited to 200 characters</p>
                  <textarea
                    autoFocus
                    className="input input--textarea-error-messages"
                    maxLength="200"
                    value={replyMsg}
                    onChange={(e) => { 
                      setReplyMsg(e.target.value)
                      setErrorId(error.id)
                    }}
                  ></textarea>
                </div>
              )}
              <li className="flex flex--flex-start">
                <div className="flex__child error-messsages__date">
                  {error.enteredDate}
                </div>
                <div className="flex__child">
                  <div className="error-messsages__type ut-color-red">
                    Error Message
                  </div>
                  {error.analystInitials && <div className="error-messsages__email">{error.analystInitials}</div>}
                  <div className="error-messsages__message">{error.error}</div>
                  {error.reply && error.reply.length > 0 && (
                    <div className="error-messsages__message">
                      <b>Reply:</b> {error.reply}
                    </div>
                  )}
                </div>
              </li>
          </div>
          ))}
        </ul>
      </section>
      )}
      <AlertModal
        focus="victimIdBtn"
        closeModal={setAlertModal}
        modal={alertModal}
      />
    </>
  );
};

export default ReturnedErrorMessages;
